import { Box } from "@mui/material";
import "./Style.css";


const DesktopView = () => {

    return (
        <Box className="desktopView">
            <h1>DesktopView</h1>
        </Box>
    )
};

export default DesktopView;